import {Space, Tabs} from "antd";
import {
  LiveEventEventTypeFormFieldsType,
  LiveEventEventTypeTopicTypeFormFieldsProps,
} from "../types";
import {useFormContext} from "react-hook-form";
import {LiveEventEventTypeTopicTypeSingleEventFormField} from "./single-event";
import {LiveEventEventTypeTopicTypeSeriesEventFormField} from "./series-event";

export function LiveEventEventTypeTopicTypeFormFields({
  formType,
}: LiveEventEventTypeTopicTypeFormFieldsProps) {
  const {clearErrors, setValue} = useFormContext<LiveEventEventTypeFormFieldsType>();
  function handleClassTypeSwitch(topicType: string) {
    if (topicType === "single") {
      setValue("classSeries", []);
      setValue("topicType", "single");
      clearErrors("classSeries");
    }
    if (topicType === "series") {
      clearErrors(["startDate", "startTime", "duration", "customDuration"]);
      setValue("topicType", "series");
    }
  }

  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <Tabs onTabClick={handleClassTypeSwitch} defaultActiveKey={"single"}>
        <Tabs.TabPane disabled={formType === "edit"} tab="Single event" key="single">
          <LiveEventEventTypeTopicTypeSingleEventFormField formType={formType} />
        </Tabs.TabPane>
        <Tabs.TabPane disabled={formType === "edit"} tab="Event series" key="series">
          <LiveEventEventTypeTopicTypeSeriesEventFormField formType={formType} />
        </Tabs.TabPane>
      </Tabs>
    </Space>
  );
}
